import { Helmet } from "react-helmet-async";

// Public production origin (custom domain connected to the deployment).
// Keep in sync with index.html canonical + sitemap.xml + robots.txt.
export const SITE_ORIGIN = "https://goodwinguard.com";
const DEFAULT_IMAGE = `${SITE_ORIGIN}/og-image.png`;
const DEFAULT_TITLE = "HospiceGuard | Hospice Audit Defense & LCD Compliance Platform";

/**
 * Per-page SEO tags for the public marketing pages. Overrides the static
 * defaults in index.html (title, description, canonical, OG/Twitter) so each
 * page ranks for its own intent instead of sharing the homepage's metadata.
 */
export default function SEO({ title, description, path = "", image = DEFAULT_IMAGE, keywords }) {
  const url = `${SITE_ORIGIN}${path}`;
  const fullTitle = title || DEFAULT_TITLE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:url" content={url} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
